import { cn } from '@/lib/utils';
import { formatDate, parseLocalDate } from '@/lib/date';

export function DueDateCell({ dueDate, compact }: { dueDate?: string; compact?: boolean }) {
  if (!dueDate) return <span className="text-sm text-muted-foreground">—</span>;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = parseLocalDate(dueDate);
  const isOverdue = due < today;
  return (
    <span
      className={cn(
        'text-sm font-medium whitespace-nowrap',
        isOverdue ? 'text-red-500' : 'text-muted-foreground',
      )}
    >
      {isOverdue && '⚠ '}
      {formatDate(dueDate, compact ? { month: 'short', day: 'numeric' } : { dateStyle: 'medium' })}
    </span>
  );
}
